// Google recommends Offer.priceValidUntil so a price isn't treated as stale.
// We don't track per-product price expiry, so we use a rolling far-future date:
// the last day of next year. Computed from `now` (injectable for tests).
export const endOfNextYearISODate = (now: Date = new Date()): string =>
  `${now.getFullYear() + 1}-12-31`;
